import { fireStore } from 'firebase/firebase';
import recursiveDelete from 'firebase/functions/recursiveDelete';
import moment from 'moment';

export default ({ currentUser, template, brands, industries, categories, volumes, collectionName }) => {
  const collection = collectionName === 'buzzs' ? 'brand' : 'campaign';
  recursiveDelete(collectionName);
  return brands.map((_, i) => fireStore.collection(collectionName).add({
    index: i + 1,
    [collection]: brands[i],
    industry: industries[i],
    category: categories[i],
    value: volumes[i] * 1,
    created_at: moment().unix(),
    updated_at: moment().unix(),
    created_by: currentUser,
    updated_by: currentUser,
  }));
};
